<template>
  <div class="carte-de-fidelite py-5">
    <div class="case" v-for="(paiement, index) in paiementsCompletes" :key="paiement.id">
      <div
        class="d-flex align-center justify-space-around"
        :style="paiement.montant != '' ? 'cursor:pointer' : ''"
        @click="paiement.montant != '' ? $emit('edit-paiement', paiement) : null"
      >
        <div class="nombre">{{ index + 1 }}</div>
        <div>
          <div
            class="montant-commande"
          >{{ paiement.montant > 0 ? paiement.montant / 100 + " €" : ' ' }}</div>
          <div class="date">{{ paiement.montant > 0 ? paiement.dateRendered : ' ' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      paiements: Array,
    },

    computed: {
      paiementsCompletes() {
        let res = [...this.paiements];
        while (res.length < 10) {
          res.push({
            montant: "",
            dateRendered: "",
          });
        }
        return res;
      },
    },
  };
</script>

<style>
  .carte-de-fidelite {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 5px;
    grid-auto-rows: minmax(70px, auto);
    background-color: rgb(241, 241, 241);
    padding: 10px;
    border-radius: 15px;
    -webkit-box-shadow: 0px 0px 10px 2px rgba(204, 204, 204, 1);
    -moz-box-shadow: 0px 0px 10px 2px rgba(204, 204, 204, 1);
    box-shadow: 0px 0px 10px 2px rgba(204, 204, 204, 1);
  }
  .carte-de-fidelite .case {
    background-color: rgb(255, 255, 255);
    padding: 5px;
    text-align: center;
    border-radius: 19px;
  }
  .nombre {
    font-size: 40px;
    font-weight: 900;
    color: rgb(240, 240, 240);
    padding: 0px;
  }
  .montant-commande {
    font-size: 1.1rem;
    letter-spacing: -1px;
    font-weight: 900;
    color: rgb(58, 58, 58);
  }
  .date {
    font-size: 0.7rem;
  }
</style>
